import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FilterProjectInfoGroupDto } from 'src/app/web/interfaces/project/list/filterProjectInfoGroupDto';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { formatDate } from '@angular/common';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';


@Component({
  selector: 'app-close-popup-project',
  templateUrl: './close-popup-project.component.html',
  styleUrls: ['./close-popup-project.component.scss']
})
export class ClosePopupProjectComponent implements OnInit {


  closeResult = '';
  idProject: number;
  lisProject: any[] = [];
  closeCheck : any[] = [];
  listStage : any[] = [];
  listSprint: any[] = [];
  listAssignment: any[] = [];
  listRisk: any[] = [];
  listMilestone: any[] = [];
  listPayment: any[] = [];
  fecha ='';
  

  

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, 
              private modalService: NgbModal,  
              private apiService: ApiServiceProject,
              private http: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private fb: FormBuilder,
              private errorService:ErrorService) {

    config.backdrop = 'static';
    config.keyboard = false;
   }


  ngOnInit(): void {
    
    

  }

  public open(id:number) {

    this.idProject = id;

    let rs = JSON.parse(localStorage.getItem("info-mtn"));
    this.lisProject = rs;

    this.spinner.show();
    this.apiService.getService('project-close-check?id_project='+id)
    .subscribe({
      next: (rs: any) => {
        if (rs) {
          this.spinner.hide();
          this.closeCheck = rs;
          this.listStage = rs['listStage'];
          this.listSprint = rs['listSprint'];
          this.listAssignment = rs['listAssignment'];
          this.listRisk = rs['listRisk'];
          this.listMilestone = rs['listMilestone'];
          this.listPayment = rs['listPayment'];
          
        } else {
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
       this.errorService.error(error);
      },
    });
    

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async closeProject(){
    let  fecha = moment(new Date()).format("DD-MM-YYYY");

    const { value: text } = await Swal.fire({
      icon:'warning',
      title:'Cerrar',
      text:`Si esta seguro de esta accion, ingrese una descripcion de cierre y luego presione el boton OK, ${fecha}`,
      input: 'textarea',
      inputLabel: 'Message',
      heightAuto: false,
      inputPlaceholder: 'Ingresa la descripcion aqui...',
      inputAttributes: {
        'aria-label': 'Ingresa la descripcion'
      },
      showCancelButton: true
    })
    
    if (text) {
      this.spinner.show();
      let post = {
        projects_id: Number(this.idProject),
        date_close: fecha.toString(),
        description: text,
      }

      this.apiService.postService('project-close',post)
      .subscribe({
          next: (rs: any) => {
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text:'Se ha cerrado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
              
            } else {
                this.spinner.hide();
                Swal.fire({
                title:  rs.error,
                text: '',
                icon: 'error',
                heightAuto: false
                }); } },
          error: (error) => {
            this.errorService.error(error);
          },});
    }else if (text==undefined){

      Swal.fire({
        title: 'Cancelado',
        text: 'Operación cancelada.',
        icon: 'error',
        heightAuto: false
        })
    }else{
      Swal.fire({
        title: 'Descripcion no valida',
        text: 'Debe ingresar una descripcion',
        icon: 'error',
        heightAuto: false
        })

    }

    
    // Swal.fire({
    //   title:'¿Esta seguro que desar cerrar el proyecto?',
    //   text: `Si esta seguro de esta accion, ingrese una descripcion de cierre y luego presione el boton Aceptar, ${fecha}`,
    //   icon: 'warning',
    //   input :'textarea',
    //   showCancelButton: true,
    //   confirmButtonText: 'Aceptar',
    //   cancelButtonText :'No, Cancelar',
    //   heightAuto: false
    
      
    // }).then((res) =>{
    //   if(res.isConfirmed){
    //     let close =[{id,fecha,}]
    //     this.spinner.show()
    //     this.apiService.postService('znt-pgd-erp/project-close',close)
    //     .subscribe({
    //       next: (rs: any) => {
    //         if (rs) {
    //           this.spinner.hide();
    //           Swal.fire('Bien!','Se ha cerrado con exito!','success').then(()=>{location.reload()})
              
    //         } else {
    //             this.spinner.hide();
    //             Swal.fire({
                  // title:  rs.error,
                  // text: '',
                  // icon: 'error',
                  // heightAuto: false
                  // }); } },
    //       error: (error) => {
    //         this.spinner.hide();
    //         Swal.fire({title:  error.error.message +'',text: '',icon: 'error',heightAuto: false});
    //       },});
    //   }
    //   else if ( res.dismiss === Swal.DismissReason.cancel){
    //     Swal.fire(
    //       'Cancelado',
    //       'Operación cancelada.',
    //       'error'
    //     )
    //   }
    // });
  }


}




